import path from 'path';
import OptimizeCssAssetsPlugin from 'optimize-css-assets-webpack-plugin';
import MiniCssExtractPlugin from 'mini-css-extract-plugin';
import { getPostCssOptions } from './postcss.config';

function loadTheme(theme) {
  if (!theme) {
    return null;
  }

  if (typeof theme === 'string') {
    return require(theme);
  }

  return theme;
}

exports.load = (config, options = {}) => {
  const isDev = process.env.NODE_ENV === 'development';

  let enableSass = true;

  try {
    require.resolve('sass-loader');
  } catch (e) {
    enableSass = false;
  }

  const cssOpts = {
    importLoaders: 1,
    sourceMap: false,
    ...(options.cssLoaderOptions || {}),
  };

  const cssModulesConfig = {
    modules: {
      localIdentName: isDev ? '[name]__[local]___[hash:base64:5]' : '[local]___[hash:base64:5]',
    },
  };

  const cssLoader = options.target === 'node' ? 'css-loader/locals' : 'css-loader';

  const postcssLoader = {
    loader: 'postcss-loader',
    options: getPostCssOptions(options),
  };

  const lessLoader = {
    loader: 'less-loader',
    options: {
      modifyVars: loadTheme(options.theme),
      javascriptEnabled: true,
      ...(options.lessLoaderOptions || {}),
    },
  };

  const sassLoader = {
    loader: 'sass-loader',
    options: {
      ...(options.sass || {}),
    },
  };

  const testCssExclude = (filePath, excludePath) => {
    if (excludePath instanceof RegExp) {
      return excludePath.test(filePath);
    } else {
      return filePath.indexOf(path.resolve(process.cwd(), excludePath)) > -1;
    }
  };

  function cssExclude(filePath) {
    if (/node_modules/.test(filePath)) {
      return true;
    }

    const extraExclude = [].concat(options.cssModulesExcludes || []);

    if (extraExclude.some(excludePath => testCssExclude(filePath, excludePath))) {
      return true;
    }

    return false;
  }

  // 应用rules
  function applyCSSRules(rule, { test, cssModules, less, sass, include, exclude, extract }) {
    const cssLoaderResolved = {
      loader: cssLoader,
      options: {
        ...cssOpts,
        ...(cssModules ? cssModulesConfig : {}),
      },
    };

    const use = [cssLoaderResolved, postcssLoader];

    if (less) {
      use.push(lessLoader);
    }

    if (sass) {
      use.push(sassLoader);
    }

    if (extract) {
      use.unshift({
        loader: MiniCssExtractPlugin.loader,
        options: {
          hmr: isDev,
        },
      });
    }

    config.add(`rule.${rule}`, {
      test,
      include,
      exclude,
      use,
    });
  }

  // 更新optimization
  config.concat(
    'optimization.minimizer',
    new OptimizeCssAssetsPlugin({
      cssProcessor: require('cssnano'),
      cssProcessorOptions: {
        discardComments: {
          removeAll: true,
        },
        // 取消css前缀，postcss已添加有
        autoprefixer: false,
        // 取消@keyframes动画被改名
        reduceIdents: false,
        // 取消重新计算zIndex
        zIndex: false,
      },
      canPrint: true,
    }),
  );

  if (options.target === 'node') {
    applyCSSRules('less', {
      test: /\.less$/,
      less: true,
    });

    applyCSSRules('css', {
      test: /\.css$/,
    });

    if (enableSass) {
      applyCSSRules('sass', {
        test: /\.(sass|scss)$/,
        sass: true,
      });
    }
  } else {
    config.add(
      'plugin.MiniCssExtractPlugin',
      new MiniCssExtractPlugin({
        ignoreOrder: true,
        filename: options.hash ? '[name].[contenthash:8].css' : '[name].css',
      }),
    );

    applyCSSRules('less', {
      test: /\.less$/,
      less: true,
      extract: true,
      cssModules: !options.disableCSSModules,
      exclude: cssExclude,
    });

    applyCSSRules('less-in-mode_modules', {
      test: /\.less$/,
      less: true,
      extract: true,
      include: /node_modules/,
    });

    applyCSSRules('css', {
      test: /\.css$/,
      extract: true,
      cssModules: !options.disableCSSModules,
      exclude: cssExclude,
    });

    applyCSSRules('css-in-node_modules', {
      test: /\.css$/,
      extract: true,
      include: /node_modules/,
    });

    if (enableSass) {
      applyCSSRules('sass', {
        test: /\.(sass|scss)$/,
        sass: true,
        extract: true,
        cssModules: !options.disableCSSModules,
        exclude: cssExclude,
      });

      applyCSSRules('sass-in-mode_modules', {
        test: /\.(sass|scss)$/,
        sass: true,
        extract: true,
        include: /node_modules/,
      });
    }

    if (Array.isArray(options.cssModulesExcludes)) {
      options.cssModulesExcludes.forEach((excludePath, index) => {
        const ext = path.extname(excludePath.toString().replace(/[$\/]+$/, '')).toLocaleLowerCase();
        applyCSSRules(`cssModulesExcludes_${index}`, {
          test: filePath => testCssExclude(filePath, excludePath),
          extract: true,
          less: ext === '.less',
          sass: ext === '.sass' || ext === '.scss',
          exclude: /node_modules/,
        });
      });
    }
  }
};
